import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';

import { TransferListComponent } from './transfer-list/transfer-list.component';
import { TransferSearchComponent } from './transfer-search/transfer-search.component';
import { TransferComponent } from './transfer.component';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    DragDropModule,
    NzCheckboxModule,
    NzButtonModule,
    NzInputModule,
    NzIconModule,
  ],
  declarations: [TransferComponent, TransferListComponent, TransferSearchComponent],
})
export class DtTransferModule {}
